// Posting — the card fee rate (D195). Its own file so history and reference share it without a cycle.
export const CARD_FEE_RATE = 0.03;
